import * as React from 'react';
import { Props } from 'react';

import './HomeView.scss';
import i18next from 'i18next';

const online_otp = {
    photo: require('../../../assets/online_otp_photo.jpeg'),
    cinemas_link: 'https://www.giftery.ru/giftcards/hobby/',
    watch_learn_link: 'https://smotriuchis.ru/'
};

interface HomeViewProps extends Props<HomeView> {
    channelId: string;
}

export class HomeView extends React.Component<HomeViewProps> {
    render() {
        /*const {channelId} = this.props;*/
        return (
            <div className='travels-container'>
                <div className='travels-container-content'>
                    <div
                        className='online-otp-photo'
                    >
                        <img src={online_otp.photo}/>
                    </div>
                    <div className='online-otp-description'>
                        <div className='online-otp-description-content'>
                            {i18next.t('access_to_online_otp')}
                        </div>
                        <div className='online-otp-description-content'>
                            {i18next.t('denomination_otp')}
                            <a href={online_otp.cinemas_link}>{i18next.t('here')}</a>
                        </div>
                        <div className='online-otp-description-content'>
                            {i18next.t('online_training_courses')}
                        </div>
                        <div className='online-otp-description-content'>
                            {i18next.t('select_otp')}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/OnlineOtp/Home/HomeView.tsx